import axios from "axios";
import { BASE_URL } from "./ApiEndPonts";

// 🔐 Get token from localStorage
function getToken() {
  try {
    const data = localStorage.getItem("accessToken");
    const parsed = data ? JSON.parse(data) : null;

    console.log("TOKEN:", parsed?.accessToken);

    return parsed?.accessToken || "";
  } catch (err) {
    return "";
  }
}

// 🌐 Axios instance
const axiosHttp = axios.create({
  baseURL: BASE_URL,
  timeout: 50000,
});

// 📤 Request interceptor (token attach)
axiosHttp.interceptors.request.use(
  (config) => {
    const token = getToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// 📥 Response interceptor (error handle)
axiosHttp.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;

    // // 🔐 Unauthorized → logout
    // if (response?.status === 401) {
    //   localStorage.removeItem("userToken");
    //   window.location.href = "/login"; // redirect
    // }

    const errorData = response
      ? {
          data: response.data,
          status: response.status,
        }
      : {
          message: "Network Error",
        };

    return Promise.reject(errorData);
  }
);

export default axiosHttp;